import { expireSession } from './authSession';

// Same-origin SSE with Authorization headers and visible HTTP errors.
// Credentials never travel in a URL or its access logs.
export default class AuthenticatedEventSource {
  constructor(url) {
    this.controller = new AbortController();
    this.closed = false;
    this.run(url);
  }
  close() { this.closed = true; this.controller.abort(); }
  async run(url) {
    const token = localStorage.getItem('auth_token');
    try {
      const target = new URL(url, window.location.href);
      if (target.origin !== window.location.origin || !target.pathname.startsWith('/api/')) {
        throw new Error('Недопустимый адрес потока');
      }
      const response = await fetch(target.href, { headers: {
        Accept: 'text/event-stream', ...(token ? { Authorization: `Bearer ${token}` } : {}),
      }, signal: this.controller.signal });
      if (!response.ok) {
        if (response.status === 401) expireSession(token);
        const error = new Error(response.status === 401 ? 'Сессия истекла. Войдите снова.' :
          response.status === 403 ? 'Недостаточно прав для загрузки данных.' : `Ошибка загрузки: HTTP ${response.status}`);
        error.status = response.status;
        throw error;
      }
      if (!response.headers.get('content-type')?.includes('text/event-stream')) {
        throw new Error('Сервер не вернул поток данных');
      }
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      while (!this.closed) {
        const { value, done } = await reader.read();
        buffer += decoder.decode(value, { stream: !done });
        let match;
        while (!this.closed && (match = /\r?\n\r?\n/.exec(buffer))) {
          const block = buffer.slice(0, match.index);
          buffer = buffer.slice(match.index + match[0].length);
          const data = block.split(/\r?\n/).filter(line => line.startsWith('data:'))
            .map(line => line.slice(5).replace(/^ /, '')).join('\n');
          if (data) this.onmessage?.({ data });
        }
        if (done) {
          if (!this.closed) throw new Error('Соединение завершилось до окончания загрузки. Повторите попытку.');
          break;
        }
      }
    } catch (error) {
      if (!this.closed && error.name !== 'AbortError') this.onerror?.(error);
    } finally {
      this.close();
    }
  }
}
